import styled, { css } from 'styled-components';
import { px2rem } from '../../helpers/rem.mjs';
import { H8Bold, B4Regular } from '../../designSystem/typos.mjs';
import { useSingleLineStyle } from '../../designSystem/styles.mjs';
import { GNB_HEIGHT, MENU_WIDTH } from './constants.mjs';
import '../../designSystem/BGLevel/components/BGLevel1.mjs';
import '../../designSystem/BGLevel/components/BGLevel2.mjs';
import '../../designSystem/BGLevel/components/BGLevel3.mjs';
import '../../designSystem/BGLevel/components/BGLevel4.mjs';
import { BG_LEVEL_BACKGROUND_CLASS_NAME } from '../../designSystem/BGLevel/components/common.mjs';

var ScrollParallaxWrapper = styled.div.withConfig({
  displayName: "ScrollParallaxWrapper",
  componentId: "sc-wm4i9k-0"
})(["width:100%;padding:", " ", " ", ";opacity:", ";"], px2rem(16), px2rem(16), px2rem(38), function (props) {
  return props.opacity;
});
var AppBarWrapper = styled.div.withConfig({
  displayName: "AppBarWrapper",
  componentId: "sc-wm4i9k-1"
})(["display:flex;align-items:center;width:", ";height:", ";", ";"], function (props) {
  return props.fixedWidth ? px2rem(props.fixedWidth) : "100%";
}, px2rem(GNB_HEIGHT), function (props) {
  return props.wrapperStyle;
});
var stickyWrapperStyle = css(["width:100%;height:", ";z-index:", ";", ";"], px2rem(GNB_HEIGHT), function (props) {
  return props.theme.zIndexes.gnbSticky;
}, function (props) {
  return props.overrideStickyStyle;
});
var StickyWrapper = styled.div.attrs({
  className: BG_LEVEL_BACKGROUND_CLASS_NAME
}).withConfig({
  displayName: "StickyWrapper",
  componentId: "sc-wm4i9k-2"
})(["", ""], stickyWrapperStyle);
var Wrapper = styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-wm4i9k-3"
})(["width:100%;", ";"], function (props) {
  return props.isSticky ? css(["margin-top:", ";", "{position:fixed;top:0;z-index:", ";will-change:scroll-position;", ";}"], px2rem(MENU_WIDTH), StickyWrapper, props.theme.zIndexes.gnbSticky, props.isParallaxVisible ? null : props.wrapperStickedStyle) : null;
});
var LeftWrapper = styled.div.withConfig({
  displayName: "LeftWrapper",
  componentId: "sc-wm4i9k-4"
})(["display:flex;align-items:center;height:100%;width:", ";min-width:", ";"], function (props) {
  return props.sideElementWidth ? "".concat(px2rem(props.sideElementWidth)) : "fit-content";
}, px2rem(16));
var CenterWrapper = styled.div.withConfig({
  displayName: "CenterWrapper",
  componentId: "sc-wm4i9k-5"
})(["flex:1;min-width:0;height:100%;"]);
var RightWrapper = styled.div.withConfig({
  displayName: "RightWrapper",
  componentId: "sc-wm4i9k-6"
})(["display:flex;align-items:center;height:100%;width:", ";"], function (props) {
  return props.sideElementWidth ? "".concat(px2rem(props.sideElementWidth)) : "fit-content";
});
var TitleContainer = styled.div.withConfig({
  displayName: "TitleContainer",
  componentId: "sc-wm4i9k-7"
})(["width:100%;height:100%;display:flex;align-items:center;justify-content:", ";text-align:", ";opacity:", ";color:", ";transition:opacity 200ms ease-in-out;"], function (props) {
  return props.alignment === "Center" ? "center" : "flex-start";
}, function (props) {
  return props.alignment === "Center" ? "center" : "start";
}, function (props) {
  return props.opacity;
}, function (props) {
  return props.theme.colorV2.colorSet.grey800;
});
var SingleLine = css(["width:100%;", ";white-space:pre;"], useSingleLineStyle);
var MainTitle = styled(H8Bold).withConfig({
  displayName: "MainTitle",
  componentId: "sc-wm4i9k-8"
})(["", ";"], SingleLine);
var SubTitle = styled(B4Regular).withConfig({
  displayName: "SubTitle",
  componentId: "sc-wm4i9k-9"
})(["color:", ";", ";"], function (props) {
  return props.theme.colorV2.colorSet.grey300;
}, SingleLine);

export { AppBarWrapper, CenterWrapper, LeftWrapper, MainTitle, RightWrapper, ScrollParallaxWrapper, StickyWrapper, SubTitle, TitleContainer, Wrapper, stickyWrapperStyle };
